import Vue from "vue";
import {BootstrapVue, IconsPlugin} from "bootstrap-vue";
import App from "./App.vue";
// Service worker disabled — it pinned old app.js and broke /koneko-a navigation.
// import "./registerServiceWorker";
import {ensureFreshHrAssets} from "./utils/ensureFreshHrAssets";
import router from "./router";
import store from "./store";
import vuetifyPlugin from "./plugins/vuetify";
import axios from "axios";
import VueAxios from "vue-axios";
import Vuex from "vuex";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import {TinyEmitter} from "tiny-emitter";
import "./main.css";
import Vuetify from "vuetify";
export const bus = new TinyEmitter();

// Install BootstrapVue
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Vuex);
Vue.use(Vuetify);
Vue.use(VueAxios, axios);
Vue.config.productionTip = false;

async function purgeLegacyServiceWorkers() {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator))
    return;
  try {
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs.map((r) => r.unregister()));
  } catch {
    // ignore
  }
}

async function boot() {
  await purgeLegacyServiceWorkers();
  await ensureFreshHrAssets();
  new Vue({
    router,
    store,
    vuetify: vuetifyPlugin,
    render: (h) => h(App),
  }).$mount("#app");
}

boot();
